import { render, staticRenderFns } from "./SearchPageHotelCardRightBlockPriceToolTip.vue?vue&type=template&id=4fc51a12&scoped=true"
import script from "./SearchPageHotelCardRightBlockPriceToolTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageHotelCardRightBlockPriceToolTip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchPageHotelCardRightBlockPriceToolTip.vue?vue&type=style&index=0&id=4fc51a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc51a12",
  null
  
)

export default component.exports